var angular = require('angular');
var app = angular.module('learn-directives');

import { ChakraProvider } from '@chakra-ui/react';
import Layout from '../../side-navigation/side-navigation-app';
import React from 'react';
import { createRoot } from 'react-dom/client';

const layoutProps = {
  user: null,
  company: null,
  initialOpen: false,
  accessHelper: null,
  urlLookup: null,
  application: null,
};

function renderLayout(root, layoutProps) {
  root.render(
    <ChakraProvider>
      <Layout {...layoutProps} />
    </ChakraProvider>
  );
}

const reactDirective = app.directive('sideNavigationDirective', [
  'Application',
  'Authorization',
  'AccessHelper',
  'UrlLookup',
  '$translate',
  function (Application, Authorization, AccessHelper, UrlLookup, $translate) {
    return {
      template: '<div id="side-navigation-app" class="react-part">Side Navigation</div>',
      scope: {},
      link: function (scope, el, attrs) {
        const reactapp = document.getElementById('side-navigation-app');
        const root = createRoot(reactapp);

        // const self = this;
        const { company, user } = Authorization.getAuthToken();

        // Fallback english translations
        const translations = {
          explore: 'Explore',
          dashboard: 'Dashboard',
          workshops: 'Workshops',
          managers: 'Managers',
          create: 'Create',
          createContent: 'Content',
          createAssignments: 'Assignments',
          createWorkflows: 'Workflows',
          createWorkshops: 'Workshops',
          createJourneys: 'Journeys',
          createAssessments: 'Assessments',
          createBadges: 'Badges',
          createSurveys: 'Surveys',
          admin: 'Admin',
          adminUsers: 'Users',
          adminTheme: 'Theme',
          adminIntegrations: 'Integrations',
          adminUtilities: 'Admin Utilities',
          reporting: 'Reporting',
          reportingOverview: 'Overview',
          reportingReports: 'Reports',
          reportingInsights: 'Insights',
        }

        layoutProps.user = user;
        layoutProps.company = company;
        layoutProps.accessHelper = AccessHelper;
        layoutProps.urlLookup = UrlLookup;  
        layoutProps.application = Application;
        layoutProps.translations = translations
        
        // Helper function to safely extract translated text
        const getTranslatedText = (key) => {
          const result = $translate.instant(key);
          if (typeof result === 'string') {
            return result;
          } else if (result && typeof result === 'object' && result.$$unwrapTrustedValue) {
            return result.$$unwrapTrustedValue() || key;
          }
          return key;
        };
        
        // Function to update translations and re-render
        const updateTranslations = () => {
          
          const readyTranslations = {
            explore: getTranslatedText('sideNav.explore'),
            dashboard: getTranslatedText('sideNav.dashboard'),
            workshops: getTranslatedText('sideNav.workshops'),
            managers: getTranslatedText('sideNav.managers'),
            create: getTranslatedText('sideNav.create'),
            createContent: getTranslatedText('sideNav.create.content'),
            createAssignments: getTranslatedText('sideNav.create.assignments'),
            createWorkflows: getTranslatedText('sideNav.create.workflows'),
            createWorkshops: getTranslatedText('sideNav.create.workshops'),
            createJourneys: getTranslatedText('sideNav.create.journeys'),
            createAssessments: getTranslatedText('sideNav.create.assessments'),
            createBadges: getTranslatedText('sideNav.create.badges'),
            createSurveys: getTranslatedText('sideNav.create.surveys'),
            admin: getTranslatedText('sideNav.admin'),
            adminUsers: getTranslatedText('sideNav.admin.users'),
            adminTheme: getTranslatedText('sideNav.admin.theme'),
            adminIntegrations: getTranslatedText('sideNav.admin.integrations'),
            adminUtilities: getTranslatedText('sideNav.admin.adminUtilities'),
            reporting: getTranslatedText('sideNav.reporting'),
            reportingOverview: getTranslatedText('sideNav.reporting.overview'),
            reportingReports: getTranslatedText('sideNav.reporting.reports'),
            reportingInsights: getTranslatedText('sideNav.reporting.insights'),
          };
          
          
          layoutProps.translations = readyTranslations;
          renderLayout(root, layoutProps);
        };
        
        // Wait for translation service to be ready, reset translations
        $translate.onReady(() => {
          
          updateTranslations();
        });
        
        // Watch for language changes by monitoring $translate.use()
        let currentLanguage = $translate.use();
        scope.$watch(() => $translate.use(), function(newLang, oldLang) {
          if (newLang !== oldLang && newLang) {
            
            // Add a small delay to ensure translations are loaded
            setTimeout(() => {
              updateTranslations();
            }, 100);
          }
        });
        
        // Also listen for the translate change success event as backup
        scope.$on('$translateChangeSuccess', function(event, data) {
          
          updateTranslations();
        });
        
        // Initial render with fallback translations
        renderLayout(root, layoutProps);

        scope.$watch(
          'authToken',
          function (newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue !== oldValue) {
              layoutProps.authToken = newValue;
              renderLayout(root, layoutProps);
            }
          },
          true
        );
      },    
    };
  },
]);

export default reactDirective;
